import { Entity, IEntity } from "./Entity";
import { IApp03Task } from "./App03Task";
import { IEntityCustomFields } from "./EntityCustomFields";


export interface IApp03Sprint extends IEntity, IEntityCustomFields {
    Description?: string;
    SprintNumber?: number;
    WorkflowID?: number;
    StartDate?: Date;
    EndDate?: Date;
    SprintStatus?: string;
    VelocityTarget?: string;
    ActualVelocity?: string;
    CreatedByID?: number;
    CreatedOn?: Date;
    ClosedByID?: number;
    ClosedOn?: Date;
    ModifiedOn?: Date;
    CustomerID?: number;

    App03Tasks?: IApp03Task[];

}

export class App03Sprint extends Entity implements IApp03Sprint {
    public Description = null;
    public SprintNumber = null;
    public WorkflowID = null;
    public StartDate = null;
    public EndDate = null;
    public SprintStatus = null;
    public VelocityTarget = null;
    public ActualVelocity = null;
    public CreatedByID = null;
    public CreatedOn = null;
    public ClosedByID = null;
    public ClosedOn = null;
    public ModifiedOn = null;
    public CustomerID = null;

    public CustomFields = [];

    constructor() {
        super();

    }
}


export const App03SprintStatus = {
    Planned: "Planned",
    Active: "Active",
    Completed: "Completed",
} as const;